package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val BackToTopTooltipStyle = CssStyle {
    base {
        Modifier
            .position(Position.Fixed)
            .bottom(92.px)
            .right(40.px)
            .padding(topBottom = 8.px, leftRight = 12.px)
            .backgroundColor(Color.rgba(0, 0, 0, 0.8f))
            .color(Colors.White)
            .fontSize(12.px)
            .borderRadius(6.px)
            .opacity(0)
            .pointerEvents(PointerEvents.None)
            .transition(
                Transition.of(
                    property = "opacity",
                    duration = 0.3.s,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
            .styleModifier {
                property("white-space", "nowrap")
            }
    }
}